export default "__VITE_ASSET__BL04uwJR__"